import React from "react";
import { motion } from "framer-motion";
import { FaWhatsapp, FaGlobe } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import WhatsAppFloatingButton from "./WhatsAppFloatingButton";
const SectionDemo = () => {
  const { t } = useTranslation();
  return (
    <>
    <WhatsAppFloatingButton />
    <section className="bg-white py-20 px-6 md:px-20 dark:bg-[#706F6F]">
      {/* Titre animé */}
      <motion.h2
        className=" text-green-500 text-4xl md:text-4xl font-bold text-center mb-16"
        initial={{ opacity: 0, y: -40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        {t("sectionDemo.title")}
      </motion.h2>

      {/* Deux colonnes */}
      <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto text-center">
        {/* WhatsApp */}
        <motion.div
          className="flex flex-col items-center"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <div className="bg-black text-white p-6 rounded-full mb-4 shadow-lg">
            <FaWhatsapp className="text-4xl text-green-500" />
          </div>
          <h3 className="text-xl font-bold">
            {t("sectionDemo.title1")} <br />
            <span className="bg-green-200 px-2 py-1 rounded-md dark:bg-green-500 ">
              {" "}
              {t("sectionDemo.title2")}
            </span>
          </h3>
          <motion.video
            className="mt-6 rounded-xl shadow-lg max-h-[350px]"
            initial={{ scale: 0.8, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
            controls
          >
            <source
              src={require("../videos/WhatsApp Video 2025-08-07 at 16.01.00.mp4")}
              type="video/mp4"
            />
            {t("sectionDemo.title3")}
          </motion.video>
        </motion.div>

        {/* Site Web */}
        <motion.div
          className="flex flex-col items-center"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <div className="bg-black text-white p-6 rounded-full mb-4 shadow-lg">
            <FaGlobe className="text-4xl text-blue-500" />
          </div>
          <h3 className="text-xl font-bold">
            {t("sectionDemo.title4")} <br />
            <span className="bg-green-200 px-2 py-1 rounded-md dark:bg-green-500 ">
              {t("sectionDemo.title5")}
            </span>
          </h3>
          <motion.video
            className="mt-6 rounded-xl shadow-lg max-h-[350px]"
            initial={{ scale: 0.8, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            viewport={{ once: true }}
            controls
          >
            <source
              src={require("../videos/WhatsApp Video 2025-08-19 at 10.22.09.mp4")}
              type="video/mp4"
            />
            {t("sectionDemo.title3")}
          </motion.video>
        </motion.div>
      </div>
      {/* <div className="flex flex-wrap justify-center items-center gap-10 mt-20">
        <div className="w-full md:w-1/2 lg:w-1/3 aspect-video">
          <iframe
            className="w-full h-full rounded-xl shadow-lg"
            src="https://www.youtube.com/embed/B0L8hOdg1bQ"
            title="Video 1"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>

        <div className="w-full md:w-1/2 lg:w-1/3 aspect-video">
          <iframe
            className="w-full h-full rounded-xl shadow-lg"
            src="https://www.youtube.com/embed/opdxPkEATyk"
            title="Video 2"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div> */}
        <motion.div
            className="flex items-center justify-center flex-wrap"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
        >
            <motion.img

                src={require('../../src/images/miniture.png')}
                alt='miniature'
                className=" w-auto transition-transform duration-300 ease-in-out hover:scale-110 hover:drop-shadow-lg bg-white p-2 rounded-lg"
                initial={{ scale: 0.5, opacity: 0 }}
                whileInView={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.6, delay:  0.1 }}
                viewport={{ once: true }}
            />
        </motion.div>
    </section>
    </>
  );
};

export default SectionDemo;
